import type { CompetitionBroadcasters, MatchBroadcasters } from '@shared-types/broadcaster.types';
import { getCountry } from '@utilities/country';
import { loadFromAPIs, recursiveCall } from '@utilities/fetch';
import { apiKey, broadcasterApiUrl } from '@utilities/WindowContext';

export const fetchBroadcasters = async (
  params: {
    startDate?: string;
    endDate?: string;
    competitionId?: string;
    matchDayId?: string;
    roundId?: string;
    countryCode?: string;
    regionCode?: string;
    limit?: number;
    offset?: number;
  },
  signal?: AbortSignal,
) => {
  if (!params.countryCode) {
    const country = await getCountry(signal);
    params.countryCode = country?.countryCodeShort;
    params.regionCode = country?.regionCodeShort;
  }

  return recursiveCall<MatchBroadcasters>('v1/broadcasters', params, {
    apiUrl: broadcasterApiUrl,
    apiKey,
    signal,
    dataProperty: 'data',
  });
};

export const fetchCompetitionBroadcasters = (
  params: {
    countryCode: string;
    apiBaseUrl?: string;
  },
  signal?: AbortSignal,
) =>
  loadFromAPIs<CompetitionBroadcasters[]>(
    // `broadcasters/${params.countryCode}.json`,
    `v1/competition-broadcasters?fifaCountryCode=${params.countryCode}&competitionContext=1:2025,14:2025,2019:2025,28:2025,9:2025,2008:2025,27:2025`,
    {},
    {
      apiKey,
      apiUrl: params.apiBaseUrl ?? broadcasterApiUrl,
      signal,
    },
  );

/**
 * Fetches competition broadcasters for a specific country using CORS fetch
 * !!!! ATTENTION !!!! this function is temporary and should be removed as soon as we have teh fsp implementation
 * @param params - Parameters for fetching broadcasters, including country code and optional API base URL
 * @param signal - Optional AbortSignal to cancel the request
 * @returns A promise resolving to an array of competition broadcasters
 * @throws {Error} If the HTTP request fails
 */
export const fetchCompetitionBroadcastersCors = async (
  params: { countryCode: string; apiBaseUrl?: string },
  signal?: AbortSignal,
) => {
  const response = await fetch(`${params.apiBaseUrl ?? broadcasterApiUrl}/broadcasters/${params.countryCode}.json`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    credentials: 'include',
    signal, // Pass the AbortSignal to the fetch request
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json() as Promise<CompetitionBroadcasters[]>;
};
